import React from 'react';
import { Column } from 'react-table';

import { FeedbackDishGroupReportMenuItem } from 'http/Api/Feedback/types';

import { withArrow } from 'components/Table/helpers';
import Icon from 'components/Icon/Icon';
import Button from 'components/Button/Button';

import style from './FeedbackDishGroupsReportTab.module.scss';
import {
  getFeedbackAvgRatingColor,
  getFeedbackRatingColor,
} from 'helpers/feedback';

const config = (
  onMenuItemAnalyticsClick: (item: FeedbackDishGroupReportMenuItem) => void,
): Column[] => [
  {
    Header: withArrow('title.report.name'),
    accessor: 'title',
    resizable: true,
  },
  {
    Header: withArrow('title.report.feedback.avgRating'),
    accessor: 'avgRating',
    resizable: true,
    width: 180,
    Cell: cell => {
      const avgRating = cell.value as FeedbackDishGroupReportMenuItem['avgRating'];

      return (
        <span style={{ color: getFeedbackAvgRatingColor(avgRating) }}>
          {avgRating}%
        </span>
      );
    },
  },
  {
    Header: withArrow('title.report.feedback.minRating'),
    accessor: 'minRating',
    resizable: true,
    width: 210,
    Cell: cell => {
      const minRating = cell.value as FeedbackDishGroupReportMenuItem['minRating'];

      return (
        <span style={{ color: getFeedbackRatingColor(minRating) }}>
          {minRating}
        </span>
      );
    },
  },
  {
    Header: withArrow('title.report.feedback.maxRating'),
    accessor: 'maxRating',
    resizable: true,
    width: 160,
    Cell: cell => {
      const maxRating = cell.value as FeedbackDishGroupReportMenuItem['maxRating'];

      return (
        <span style={{ color: getFeedbackRatingColor(maxRating) }}>
          {maxRating}
        </span>
      );
    },
  },
  {
    Header: withArrow('title.report.feedback.course'),
    accessor: '',
    resizable: false,
    sortable: false,
    headerClassName: style.print__hide,
    className: style.print__hide,
    width: 80,
    Cell: cell => {
      return (
        <div className={style.cell__course}>
          <Button
            styleType="text"
            onClick={() => onMenuItemAnalyticsClick(cell.value)}
          >
            <Icon type="statistic" />
          </Button>
        </div>
      );
    },
  },
];

export default config;
